/**
 * ModuleShell — envoltura de módulo estilo "Compras" del diseño:
 * el módulo entero es una TARJETA BLANCA redondeada; arriba el header
 * (chip de icono verde + título grande + subtítulo + acción) con borde
 * inferior, y los filtros van DENTRO del header (debajo del título).
 * El cuerpo del módulo va en `children`.
 *
 *   icon: componente lucide
 *   title, subtitle
 *   action: nodo a la derecha (botón primario)
 *   filters: nodo de filtros (pills Salonika) — se muestra dentro del header
 */
import { cn } from '@/lib/utils'

export function ModuleShell({ icon: Icon, title, subtitle, action, filters, children, className }) {
  return (
    <div className={cn('bg-white', className)}>
      <div className="px-4 sm:px-6 md:px-8 pt-5 sm:pt-6 pb-5 border-b border-expo-line">
        <div className="flex items-start justify-between gap-3 sm:gap-5 flex-wrap">
          <div className="flex items-center gap-3 sm:gap-4 min-w-0">
            {Icon ? (
              <div
                className="w-12 h-12 sm:w-16 sm:h-16 rounded-[14px] sm:rounded-[18px] flex items-center justify-center flex-none"
                style={{ background: '#033021', color: '#C3DB5A', boxShadow: '0 10px 24px rgba(3,48,33,0.28)' }}
              >
                <Icon className="w-6 h-6 sm:w-7 sm:h-7" />
              </div>
            ) : null}
            <div className="min-w-0">
              <h2
                className="font-display font-bold text-2xl sm:text-3xl md:text-[42px] leading-none"
                style={{ color: '#15321F', fontWeight: 800, letterSpacing: '-0.02em' }}
              >
                {title}
              </h2>
              <div className="mt-2 sm:mt-3" style={{ width: '64px', height: '5px', borderRadius: '3px', background: '#A9C93C' }} />
              {subtitle ? <p className="text-sm sm:text-[16px] mt-2" style={{ color: '#8B9B8F' }}>{subtitle}</p> : null}
            </div>
          </div>
          {action ? <div className="flex-none">{action}</div> : null}
        </div>
        {filters ? <div className="mt-4 sm:mt-5">{filters}</div> : null}
      </div>
      <div className="p-4 sm:p-6 md:p-8">{children}</div>
    </div>
  )
}
